import { createClient } from "@supabase/supabase-js";

require("dotenv").config();

const { REACT_APP_SUPABASE_URL } = process.env;
const { REACT_APP_SUPABASE_KEY } = process.env;

const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY);

export default supabase;

const getSupaClient = () => {
  return createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY);
};
export { getSupaClient };

/**
 * Get the current user session's workspace value
 * @param {*} supaClient : supabase client object
 * @returns : workspace uuid
 */
const getWorkspace = (supaClient) => {
  return supaClient.auth.currentUser.app_metadata.workspace;
};

export { getWorkspace };
